import { Component, OnInit, Input, ChangeDetectionStrategy, ViewEncapsulation, ChangeDetectorRef, ElementRef, OnDestroy, Output, EventEmitter } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
@Component({
  selector: 'sigv-bottom-panel',
  templateUrl: './bottom-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./bottom-panel.component.scss'],
  animations: [
    trigger('animation', [
      state(
        'void',
        style({
          opacity: 0,
          transform: 'translateY(100%)',
        })
      ),
      state(
        'open',
        style({
          opacity: 1,
          transform: 'translateY(0)',
        })
      ),
      transition('void => open', animate('{{showTransitionParams}}')),
      transition('open => void', animate('{{hideTransitionParams}}')),
    ]),
  ],
})
export class BottomPanelComponent implements OnInit, OnDestroy {

  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  scrollListener: any;
  constructor(public el: ElementRef, private cd: ChangeDetectorRef) { }

  @Input() styleClass = '';
  @Input() showTransitionOptions = '.15s';
  @Input() hideTransitionOptions = '.15s';
  @Input() threshold = 400;
  @Input() contentHeight = 0;

  ngOnInit(): void {
    this.bindDocumentScrollListener();
  }

  ngOnDestroy(): void {
    this.unbindDocumentScrollListener();
  }

  checkVisibility(scrollY: number): void {
    const target = this.threshold - (this.visible ? this.contentHeight + 10 : 0);
    if (scrollY > target) {
      this.visible = true;
    } else {
      this.visible = false;
    }
    this.visibleChange.emit(this.visible);
    this.cd.markForCheck();
  }

  bindDocumentScrollListener(): void {
    this.scrollListener = () => {
      this.checkVisibility(this.getWindowScrollTop());
    };

    window.addEventListener('scroll', this.scrollListener);
  }

  unbindDocumentScrollListener(): void {
    if (this.scrollListener) {
      window.removeEventListener('scroll', this.scrollListener);
      this.scrollListener = null;
    }
  }

  getWindowScrollTop(): number {
    const doc = document.documentElement;
    return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
  }
}
